import React, { Component } from 'react'
import Box from "@mui/material/Box";
import  BreadCrumb  from  "../../components/BreadCrumb"
import SupplierTable from "./components/SupplierTable/index"
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectData, selectLoading } from "./redux/selector"
import { useStyles } from "./styles";
import { useInjectReducer } from "redux-injectors";
import { reducer, sliceKey } from "./redux/slice";
import { AddButton } from 'app/components/Button/AddButton';

export const Suppliers = () => {

  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const rows = useSelector(selectData)
  const loading = useSelector(selectLoading)
  
  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <BreadCrumb title={t("SIDEBAR.SUPPLIERS")} iconPosition="end" />
        <Box>
          <AddButton label={t("SUPPLIERS.ADD")}/>
        </Box>
        <SupplierTable rows={rows} loading={loading} />
      </Box>
    </Box>
  )
}

export default Suppliers
